export default __webpack_public_path__ + "static/media/THAIPAT.37561df5.png";